import React, { JSX } from "react";
import { Process } from "utilities/types/processes/process";
import { ProcessNavigationFooter } from "components/processes/navigation/process-navigation-footer/process-navigation-footer";
import { ProcessNavigator } from "utilities/hooks/processes/use-process-navigator";
import { ProcessStatusDetermination } from "utilities/interfaces/processes/process-status-determination";
import { sitemap } from "sitemap";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface EditCourseLayoutFooterProps<T> {
    cssClassName?: string;
    process: Process<T>;
    processNavigator: ProcessNavigator<T>;
    processStatusDetermination: ProcessStatusDetermination;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const EditCourseLayoutFooter = <T,>(
    props: React.PropsWithChildren<EditCourseLayoutFooterProps<T>>
): JSX.Element => {
    return (
        <ProcessNavigationFooter
            cssClassName={props.cssClassName}
            process={props.process}
            processNavigator={props.processNavigator}
            processStatusDetermination={props.processStatusDetermination}
            saveAndExitPath={sitemap.admin.course.list}>
            {props.children}
        </ProcessNavigationFooter>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { EditCourseLayoutFooter };

// #endregion Exports
